import { gql } from "graphql-tag";

export default gql`
query VerifyToken($jwt: ID!, $token: String) {
	VerifyToken(jwt: $jwt, keyToken: $token) {
		uid
		isValid
		expires
	}
}`;